import React, { useState } from "react";
import PlayerAccordion from "games/PlayerAccordion";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import { useFormState } from "react-final-form";
import cc from "classcat";
import FootballPlayersFormTab from "./FootballPlayersFormTab";
import BaseballPlayersFormTab from "./BaseballPlayersFormTab";
import BasketballPlayersFormTab from "./BasketballPlayersFormTab";
import GirlsVolleyballPlayersFormTab from "./GirlsVolleyballPlayersFormTab";
import SoccerPlayersFormTab from "./SoccerPlayersFormTab";

const useStyles = makeStyles((theme) => ({
  input: {
    marginRight: theme.spacing(2)
  },
  pagination: {
    paddingTop: "20px"
  }
}));

const SeasonTeamPlayersEdit = (props) => {
  const { record = {} } = props;
  const { sportCode, players = [] } = record;
  const size = 20;
  const paginationCount = Math.ceil(players.length / size);
  const classes = useStyles();
  const { pristine } = useFormState();
  const [page, setPage] = useState(1);
  const handleChange = (event, value) => {
    setPage(value);
  };

  let Stats = null;
  if (sportCode === "football") {
    Stats = FootballPlayersFormTab;
  } else if (sportCode === "girls-volleyball") {
    Stats = GirlsVolleyballPlayersFormTab;
  } else if (sportCode === "softball" || sportCode === "baseball") {
    Stats = BaseballPlayersFormTab;
  } else if (sportCode === "girls-soccer" || sportCode === "boys-soccer") {
    Stats = SoccerPlayersFormTab;
  } else if (
    sportCode === "girls-basketball" ||
    sportCode === "boys-basketball"
  ) {
    Stats = BasketballPlayersFormTab;
  }

  const getPlayerFields = (i) => {
    return <Stats index={i + (page - 1) * size} className={classes.input} />;
  };

  const filteredPlayers = players
    .sort((a, b) => a.person.lastName.localeCompare(b.person.lastName))
    .filter((player, i) => {
      const ceiling = size * page;
      const floor = (page - 1) * size;
      return i < ceiling && i + 1 > floor;
    });

  const paginationClasses = cc([
    classes.pagination,
    { disabledPagination: !pristine }
  ]);

  return (
    <>
      <PlayerAccordion
        players={filteredPlayers}
        namePath="person.name"
        getPlayerFields={getPlayerFields}
      />
      {players.length > size && (
        <Pagination
          className={paginationClasses}
          disabled={!pristine}
          count={paginationCount}
          page={page}
          onChange={handleChange}
        />
      )}
    </>
  );
};

export default SeasonTeamPlayersEdit;
